import { getSimpleUserInfo } from "@/utill/auth";
import { getFunctionsByRole } from "@/api/role";
import { getMenuList } from "@/api/menu";
import _ from "lodash";
import systemManagement from "@/data/systemManagement";
import pageInfo from "@/data/pageInfo";
import { transformToMenuTree } from "@/utill/commom";

const state = () => ({
  systemManagement: systemManagement,
  pageInfo: pageInfo,
  userFunctions: [],
  userMenus: [],
  userMenuTree: [],
});

const getters = {
  // TODO: 안 쓰는 듯...
  // getUserFunctions: function (state) {
  //   return state.userFunctions;
  // },
  // TODO: 안 쓰는 듯...
  // getUserMenus: function (state) {
  //   return state.userMenus;
  // },
  getUserMenuTree: function (state) {
    return state.userMenuTree;
  },
};

const mutations = {
  SET_USER_FUNCTIONS: (state, functions) => {
    state.userFunctions = functions;
  },
  SET_USER_MENUS: (state, menus) => {
    state.userMenus = menus;
  },
  SET_USER_MENU_TREE: (state, menus) => {
    state.userMenuTree = menus;
  },
};

const actions = {
  // TODO: 안 쓰는 듯...
  // getUserFunctions({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     let userInfo = getSimpleUserInfo();
  //     if (userInfo) {
  //       console.log(`try to call getUserFunctions api`);
  //       getFunctionsByRole(JSON.parse(userInfo).roleId)
  //         .then((response) => {
  //           const data = response.data.response.data;
  //           commit("SET_USER_FUNCTIONS", data);
  //           resolve(data);
  //         })
  //         .catch((error) => {
  //           reject(error);
  //         });
  //     }
  //   });
  // },
  createUserMenu({ commit }) {
    return new Promise((resolve, reject) => {
      let userInfo = getSimpleUserInfo();
      let userFunctions = [];
      let allMenus = [];
      if (userInfo) {
        getFunctionsByRole(JSON.parse(userInfo).roleId)
          .then((response) => {
            userFunctions = response.data.response.data;
          })
          .then(() => {
            getMenuList().then((response) => {
              let menuList = response.data.response.data;
              menuList.forEach(function (menu) {
                let isActive = _.findIndex(userFunctions, function (o) {
                  return o.funcId == menu.funcId && o.useYn == "Y";
                });
                if (isActive > -1) {
                  allMenus.push(menu);
                }
              });
              commit("SET_USER_MENUS", allMenus);
              resolve(allMenus);
            });
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  },
  createUserMenuTree({ commit }) {
    return new Promise((resolve, reject) => {
      let userInfo = getSimpleUserInfo();
      let userFunctions = [];
      let allMenus = [];
      if (userInfo) {
        console.log(`try to call getUserFunctions api`);
        getFunctionsByRole(JSON.parse(userInfo).roleId)
          .then((response) => {
            userFunctions = response.data.response.data;
          })
          .then(() => {
            getMenuList().then((response) => {
              let menuList = response.data.response.data;
              menuList = menuList.filter(
                (obj) => obj.funcNm !== "앱 로그 조회"
              ); // 앱 로그 조회 임시 필터링 22.09.02
              // 삭제된 메뉴 Header에 표시하지 않도록 처리 22.09.15
              menuList = menuList.filter((obj) => obj.useYn !== "N");
              menuList.forEach(function (menu) {
                let isActive = _.findIndex(userFunctions, function (o) {
                  return o.funcId === menu.funcId && o.useYn === "Y";
                });
                if (isActive > -1) {
                  allMenus.push(menu);
                }
              });
              let parents = [];
              let children = [];
              allMenus.forEach(function (menu) {
                menu.subMenu = [];
                if (menu.menuHighId === "") {
                  parents.push(menu);
                }
              });
              children = allMenus.filter(function (menu) {
                return menu.menuHighId !== "";
              });
              transformToMenuTree(parents, children);
              commit("SET_USER_MENU_TREE", parents);
              resolve(parents);
            });
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  },
};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
